import React from 'react';
import Icon from '../../../components/AppIcon';

const MSAHeader = ({ 
  title = "Master Service Agreement", 
  documentId = "MSA-2025-001",
  lastUpdated = "Jan 11, 2025",
  status = "Active"
}) => {
  return (
    <header className="sticky top-0 z-50 bg-card border-b border-border shadow-sm">
      <div className="flex items-center justify-between h-16 px-6 max-w-7xl mx-auto">
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
              <Icon name="FileText" size={20} className="text-primary-foreground" />
            </div>
            <div className="flex flex-col">
              <h1 className="text-xl font-semibold text-foreground leading-tight">
                MSA Viewer
              </h1>
              <span className="text-xs text-muted-foreground">
                Document Management System
              </span>
            </div>
          </div>
          
          <div className="h-8 w-px bg-border" />
          
          <div className="flex flex-col">
            <h2 className="text-lg font-medium text-foreground leading-tight">
              {title}
            </h2>
            <span className="text-sm text-muted-foreground font-mono">
              Document ID: {documentId}
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-6">
          <div className="hidden md:flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>Last Updated:</span>
            <span className="font-mono text-foreground">{lastUpdated}</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span className="text-sm font-medium text-success">{status}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MSAHeader;